import store from '../store';
import Auth from 'services/Auth';

/**
 * Route helper
 *
 * @param   {string}    path        The route path
 * @param   {string}    name        The route name
 * @param   {object}    component   The component definition
 * @param   {object[]}  options     Additional options objects
 * @returns {{path: string, name: string, component: object, ...options:object[]}}
 */
export function route(path, name, component, ...options) {
  // convert variadic options array to single object
  const opts = options.reduce((obj, val) => ({ ...obj, ...val }), {});
  return { path, name, component, ...opts };
}

/**
 * Helper function to check if user is logged in
 */
export function isLoggedIn() {
  return store.getters['account/isLoggedIn'];
}

/**
 * Redirect to login if a logged out user tries to visit a route protected by authorization
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
export function authorize(to, from, next) {
  try {
    if (!isLoggedIn()) {
      Auth.refresh().then(state => {
        if (state) {
          return next();
        }

        const redirectTo = to.fullPath;
        
        return next(`/login?redirectTo=${redirectTo}`);
      });
    } else {
      next();
    }
  } catch (err) {
    // Redirection via navigation guard throws error due to a redesign in vue-router
    // Redirection works as usual
    // https://github.com/vuejs/rfcs/pull/150
    // https://github.com/vuejs/vue-router/issues/2932
    // https://github.com/vuejs/vue-router/issues/2881#issuecomment-520864374
    console.log("error", err);
  }
}

/**
 * Helper function to logout immediately
 */
export function logout(to, from, next) {
  Auth.logout();
}

/**
 * Redirect the user to "/apps" if they dont have either developer or spectator role
 *
 * @export
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 * @return {*} 
 */
export function allowedToDeveloperOrSpectator(to, from, next) {
  const allowedApps = store.getters['account/getDeveloperOrSpectatorApps']
  
  if(allowedApps.includes(to.params.appId)){
    return next()
  }
  return next('/apps')
}